/**
 * Shared layout for module detail pages (AGENTS.md §4a: full width, responsive).
 */
export const detailPageContainerSx = {
  width: '100%',
  maxWidth: '100%',
  boxSizing: 'border-box' as const,
  px: { xs: 1, sm: 2 },
  pb: { xs: 2, sm: 3 },
};

export const detailFieldGridSx = {
  display: 'grid',
  gridTemplateColumns: {
    xs: 'minmax(0, 1fr)',
    sm: 'repeat(2, minmax(0, 1fr))',
    lg: 'repeat(3, minmax(0, 1fr))',
  },
  gap: 2,
  width: '100%',
};

export const detailFullRowSx = { gridColumn: '1 / -1' as const };

export const detailFieldSx = { minWidth: 0, width: '100%' } as const;

/** Header row: back + title, stacks on narrow screens */
export const detailHeaderRowSx = {
  display: 'flex',
  alignItems: { xs: 'flex-start', sm: 'center' },
  flexDirection: { xs: 'column', sm: 'row' },
  gap: 2,
  mb: 2,
};

/** Header with extra actions (e.g. „Zum Kunden“); wraps on narrow screens */
export const detailHeaderRowWrapSx = {
  display: 'flex',
  alignItems: { xs: 'flex-start', sm: 'center' },
  flexDirection: { xs: 'column', sm: 'row' },
  flexWrap: 'wrap' as const,
  gap: 2,
  mb: 2,
};

export const detailBackButtonSx = { alignSelf: { xs: 'stretch', sm: 'auto' } };

export const detailTitleSx = { typography: { xs: 'h5', sm: 'h4' } };
